import { useSelector } from 'react-redux'
import { SelectionOption } from '../../../../../../types/Survey/Element'
import Dropdown from '../../../../../UI/Dropdown/Dropdown'
import props from '../../../../../../redux/props'

export type Option = SelectionOption & { selected: boolean; priority: number }

type Props = {
  options: Option[]
  toggle: (uuid: string) => () => void
  setPriority: (uuid: string) => (prio: number) => void
}

const List: React.FC<Props> = ({ options, toggle, setPriority }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const prioOptions = [...new Array(options.filter((o) => !!o.selected).length)].map((o, i) => ({ value: i + 1, label: `${i + 1}` }))

  return (
    <div className="flex flex-col gap-2 mt-3 w-full">
      {options.map((o: Option) => (
        <div className="flex gap-3 items-end" key={o.uuid}>
          <div
            key={o.uuid}
            className={`w-full truncate py-1 px-2 transition-all cursor-pointer border border-blue ${
              o.selected ? 'bg-blue text-white' : 'text-blue bg-white hover:bg-blue hover:bg-opacity-10'
            }`}
            onClick={toggle(o.uuid)}
          >
            {o.value}
          </div>
          {o.selected && (
            <div className="w-[200px]">
              <Dropdown
                label={t.survey.answer.organizationUnitCooperationSelection.priority}
                value={o.priority}
                items={prioOptions}
                disableSearch
                onChange={setPriority(o.uuid)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default List
